const config = {
    dataUrl: process.env.REACT_APP_DATAURI,
    contentUrl: 'https://storage.googleapis.com/lutas-public'
}

export default config;
